import { render, staticRenderFns } from "./FrequencyQuestion.vue?vue&type=template&id=446bcdfd&scoped=true"
import script from "./FrequencyQuestion.vue?vue&type=script&lang=js"
export * from "./FrequencyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446bcdfd",
  null
  
)

export default component.exports